/*eslint no-script-url: 0 */
import React, { Component } from 'react';
import FrameArea from './Components/FrameArea/FrameArea';

export default class LeftSideBar extends Component {

	constructor(props) {
        super(props);
        this.state = {
			lgShow: false,
			show: false
        }
    	this.lgClose = this.lgClose.bind(this);
    	this.lgShowF = this.lgShowF.bind(this);
    }

	lgClose = () => this.setState({ lgShow: false });
	lgShowF = () => this.setState({ lgShow: true });

	render() {
	    return (
	    	<div className="col-sm-7">
    			<FrameArea
					{...this.props}
					lgShow={this.state.lgShow}
					lgShowF={this.lgShowF}
					lgClose={this.lgClose} />
			</div>
	    );
	}
}